import { PageHeader } from 'components/page-header/page-header';
import cls from './improvement-center.module.scss';
import { useCachedSelectedProject, useTranslation } from 'hooks';
import { InformationCompleteness } from 'widgets/information-completness/information-completeness';
import { useRef } from 'react';
import { TechnicalAccessibility } from 'widgets/technical-accessibility/technical-accessibility';
import { ReportError } from '../report-error/report-error';
import { ImprovementOverview } from 'widgets/improvement-overview/improvement-overview';
import { ProductRulesBlock } from 'widgets/product-rules-block/product-rules-block';

export const ImprovementCenterPage = () => {
  const { t } = useTranslation();
  const { isError } = useCachedSelectedProject();
  const technicalRef = useRef<HTMLDivElement>(null);
  const completenessRef = useRef<HTMLDivElement>(null);
  const productsRef = useRef<HTMLDivElement>(null);

  const scrollToSection = (ref: React.RefObject<HTMLDivElement | null>) => {
    ref.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  if (isError) {
    return (
      <div>
        <PageHeader />
        <ReportError />
      </div>
    );
  }

  return (
    <>
      <PageHeader pageTitle={t('improvementCenter')} />
      <div className={cls.page}>
        <ImprovementOverview
          technicalRef={technicalRef}
          completenessRef={completenessRef}
          productsRef={productsRef}
          onScrollToSection={scrollToSection}
        />

        <div ref={technicalRef} className={cls.mb16} id='tech'>
          <TechnicalAccessibility useImprovementVersion />
        </div>

        <div ref={completenessRef} className={cls.mb16} id='overview'>
          <InformationCompleteness useImprovementVersion={true} />
        </div>

        <div ref={productsRef} className={cls.mb16}>
          <ProductRulesBlock />
        </div>
      </div>
    </>
  );
};
